import initRouting from "../../commun/init-router";

export default initRouting(window.location.pathname.replace(/(?:\/session\/(?:login|reset_password\/extranet|mfa\/\w+))?\/$/, ''));
